import { render, staticRenderFns } from "./addImages.vue?vue&type=template&id=3261f790&scoped=true"
import script from "./addImages.vue?vue&type=script&lang=js"
export * from "./addImages.vue?vue&type=script&lang=js"
import style0 from "./addImages.vue?vue&type=style&index=0&id=3261f790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3261f790",
  null
  
)

export default component.exports